/**
 * Menvora — offer nudge "Ver oferta del mes 🔥" bajo LP stack (product.ads).
 * Gate: disabled + loading hasta COD Releasit listo (#rsi_buy_now_button /
 * body.is-rsi-ready / menvora:cod-cta-ready). Timeout 10s → habilita igual.
 * Click: solo scrollea a trust badges / offer-bar (sin preseleccionar oferta).
 */
(function () {
  if (window.__menvoraOfferNudge) return;
  window.__menvoraOfferNudge = true;

  var COD_GATE_POLL_MS = 200;
  var COD_GATE_TIMEOUT_MS = 10000;

  function sanitize(v) {
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.sanitize === 'function') {
      return window.MenvoraAnalytics.sanitize(v);
    }
    return String(v || 'unknown')
      .replace(/[^a-zA-Z0-9_.\- ]/g, '_')
      .slice(0, 80);
  }

  function baseParams() {
    var cfg = window.MENVORA_PDP || {};
    return {
      product_handle: sanitize(cfg.productHandle || 'unknown'),
      template: sanitize(cfg.template || 'product'),
      view: sanitize(cfg.view || 'ads'),
      path: sanitize((location.pathname || '').slice(0, 80)),
    };
  }

  function track(name, params) {
    var payload = Object.assign(baseParams(), params || {});
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function') {
      window.MenvoraAnalytics.track(name, payload);
      return;
    }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
  }

  function rsiCodCta() {
    var btns = document.querySelectorAll('#rsi_buy_now_button, [data-rsi-cod-button="true"]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (!isCodCtaInteractive(btn)) continue;
      return btn;
    }
    return null;
  }

  function isCodCtaInteractive(el) {
    if (!el || el.hidden || el.disabled) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) {
      return false;
    }
    var r = el.getBoundingClientRect();
    if (r.width < 80 || r.height < 36) return false;
    if (String(el.textContent || '').trim().length <= 3) return false;
    return true;
  }

  /** COD listo: señal del skeleton o CTA Releasit interactivo en DOM. */
  function isCodReady() {
    if (document.body.classList.contains('is-rsi-ready')) return true;
    return !!rsiCodCta();
  }

  /** Trust badges / offer-bar dock (timer + copy). Destino del scroll. */
  function trustBadgesTarget() {
    return (
      document.querySelector('[data-menvora-offer-bar-dock]') ||
      document.querySelector('[data-menvora-track="trust_badges"]') ||
      document.querySelector('.product--ads .menvora-offer-bar-dock') ||
      null
    );
  }

  /** Fallback: slot COD ATF (no floating) si no hay trust dock. */
  function atfCtaTarget() {
    var slot =
      document.querySelector('[data-menvora-ads-images] .product-form__buttons') ||
      document.querySelector('[data-menvora-cod-cta-slot="atf"]');
    if (slot) return slot;

    var landing = document.getElementById('landing-page1');
    if (landing) return landing;

    var btns = document.querySelectorAll('#rsi_buy_now_button');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.classList.contains('rsi_floating') || btn.classList.contains('rsi_floating_bottom')) continue;
      if (btn.closest('#floatingBuyNowButton')) continue;
      var cs = window.getComputedStyle(btn);
      if (cs.position === 'fixed') continue;
      return btn;
    }
    return document.querySelector('.product--ads .product-form') || null;
  }

  function stickyOffset() {
    var nodes = document.querySelectorAll(
      '.shopify-section-header-sticky, .section-header, sticky-header, .header-wrapper, [data-menvora-offer-bar].is-pinned'
    );
    var max = 0;
    nodes.forEach(function (n) {
      var h = n.offsetHeight || 0;
      if (h > max) max = h;
    });
    return max;
  }

  /**
   * Ancla trust/oferta/timer arriba (bajo sticky).
   * Con el layout ads (dock → quantity RSI → COD), el Comprar queda ~centro.
   */
  function scrollToTrustBadges() {
    var el = trustBadgesTarget() || atfCtaTarget();
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function setGateReady(btn, reason) {
    if (!btn || btn.getAttribute('data-cod-gate') === 'ready') return;
    btn.setAttribute('data-cod-gate', 'ready');
    btn.classList.remove('is-waiting-cod');
    btn.disabled = false;
    btn.setAttribute('aria-busy', 'false');
    var label = btn.querySelector('[data-menvora-offer-nudge-label]');
    var readyText = btn.getAttribute('data-label-ready') || 'Ver oferta del mes 🔥';
    if (label) label.textContent = readyText;
    else btn.textContent = readyText;
    track('CodOfferNudgeGateReady', {
      placement: 'atf_hero',
      reason: sanitize(reason || 'ready'),
    });
  }

  function armCodGate(btn) {
    if (!btn) return;
    if (isCodReady()) {
      setGateReady(btn, 'already');
      return;
    }

    var started = Date.now();
    var settled = false;

    function settle(reason) {
      if (settled) return;
      settled = true;
      window.clearInterval(pollId);
      window.clearTimeout(timeoutId);
      window.removeEventListener('menvora:cod-cta-ready', onReadyEvt);
      setGateReady(btn, reason);
    }

    function onReadyEvt() {
      settle('event');
    }

    window.addEventListener('menvora:cod-cta-ready', onReadyEvt);

    var pollId = window.setInterval(function () {
      if (isCodReady()) settle('poll');
    }, COD_GATE_POLL_MS);

    var timeoutId = window.setTimeout(function () {
      // Preferible habilitar: no bloquear para siempre si Releasit falla/tarda.
      settle(isCodReady() ? 'timeout-ready' : 'timeout-fallback');
    }, COD_GATE_TIMEOUT_MS);

    // Por si el skeleton ya disparó el evento antes de este listener.
    if (isCodReady()) settle('race');
    else if (Date.now() - started > COD_GATE_TIMEOUT_MS) settle('timeout-fallback');
  }

  function onClick(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    if (btn.disabled || btn.getAttribute('data-cod-gate') !== 'ready') return;

    track('CodOfferNudgeClick', {
      label: 'Ver_oferta_del_mes',
      placement: 'atf_hero',
    });

    var scrolled = scrollToTrustBadges();

    track('CodOfferNudgeResult', {
      scrolled: scrolled ? 1 : 0,
      placement: 'atf_hero',
    });
  }

  function init() {
    var root = document.querySelector('[data-menvora-offer-nudge]');
    var btn = document.querySelector('[data-menvora-offer-nudge-btn]');
    if (!root || !btn) return;
    btn.addEventListener('click', onClick);
    armCodGate(btn);
    track('CodOfferNudgeShow', { placement: 'atf_hero' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
